import { ConvertBoxDataType } from '../../convertBox.index';

export enum __BuyCryptoWithdrawMethodsEnums {
    wallet,
    direct,
}

export interface __BuyCryptoWithdrawMethodConvertBoxProps {
    onSubmit: (e: ConvertBoxDataType) => void;
    onBack: () => void;
    data?: ConvertBoxDataType;
    loading?: boolean;
}
